import { Fragment, useState } from 'react';

import { ContactCardPreview } from '@apps/web/components/training/contact_card_preview';
import { Button } from '@apps/web/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@apps/web/components/ui/dialog';

type StagedContactCardPreviewProps = {
    readonly displayName: string;
    readonly phoneE164: string | null;
};

export function StagedContactCardPreview({
    displayName,
    phoneE164,
}: StagedContactCardPreviewProps) {
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    return (
        <Fragment>
            <div className="bg-muted/40 mt-2 flex flex-wrap items-center gap-1.5 rounded-md px-2 py-1">
                <div className="min-w-0 flex-1">
                    <p className="text-muted-foreground text-[11px]">
                        Contact card will be sent
                    </p>
                </div>
                <Button
                    onClick={() => {
                        setIsPreviewOpen(true);
                    }}
                    size="sm"
                    type="button"
                    variant="outline"
                    className="h-7 shrink-0 px-2 text-xs"
                >
                    Preview
                </Button>
            </div>
            <Dialog onOpenChange={setIsPreviewOpen} open={isPreviewOpen}>
                <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-md">
                    <DialogHeader>
                        <DialogTitle>Contact card preview</DialogTitle>
                        <DialogDescription>
                            This contact card will be attached when you send
                            this reply.
                        </DialogDescription>
                    </DialogHeader>
                    <ContactCardPreview
                        displayName={displayName}
                        phoneE164={phoneE164}
                    />
                </DialogContent>
            </Dialog>
        </Fragment>
    );
}
